// extracted by mini-css-extract-plugin
export var border = "section-media-module--border--0+9YF";
export var container = "section-media-module--container--E20Ae";
export var title = "section-media-module--title--BCCVk";
export var videoContainer = "section-media-module--video-container--WjiOl";